// $FlowFixMe

export const button = {
  background: 'none',
  border: 0,
  color: 'inherit',
  font: 'inherit',
  lineHeight: 'normal',
  overflow: 'visible',
  padding: 0,
  cursor: 'pointer',
  outline: 'none',
  WebkitAppearance: 'button',
  WebkitUserSelect: 'none',
  MozUserSelect: 'none',
  msUserSelect: 'none',
};
